import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { CargaArchivosInventarioModal } from "./CargaArchivosInventarioModal";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { LoaderScreen } from "../../components/LoaderScreen";

export const ListadoAuditoriasProgramadasScreen = () => {
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);
    const [auditoriaSelected, setAuditoriaSelected] = useState(null);
    const [archivoSelected, setArchivoSelected] = useState(null);
    const [sucursal, setSucursal] = useState(null);
    const [openModalCarga, setOpenModalCarga] = useState(false);
    const [auditorias, setAuditorias] = useState();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenMenu = (event, auditoria) => {
        setAnchorEl(event.currentTarget);
        setAuditoriaSelected(auditoria);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleOpenModalCarga = (tipoArchivo, sucursalfolio) => {
        setArchivoSelected(tipoArchivo);
        setSucursal(sucursalfolio);
        setOpenModalCarga(true);
        handleCloseMenu();
    };

    const handleCloseModalCarga = () => {
        setOpenModalCarga(false);
        setAuditoriaSelected(null);
        setArchivoSelected(null);
        setSucursal(null);
    };

    const handleClickConteo = () => {
        history.push("/Auditoria/RealizarConteo", {
            folio: auditoriaSelected
        });
    };

    const estatusTexto = {
        'N': 'No Iniciado',
        'P': 'En Proceso',
        'V': 'Vencido',
        'F': 'Finalizado',
        'C': 'Cancelado',
        'A': 'Ajustado'
    };

    const [options, setOptions] = useState({
        sucursal: [],
        tipoConteo: [],
        auditorResp: [],
        estado: [],
    });
    const [filtros, setFiltros] = useState({
        sucursal: [],
        tipoConteo: [],
        auditorResp: [],
        estado: [],
    });
    const [prioridadFiltros, setPrioridadFiltros] = useState([]);
    const [datosFiltrados, setDatosFiltrados] = useState([]);

    const [filtrosTemp, setFiltrosTemp] = useState({
        sucursal: [],
        tipoConteo: [],
        auditorResp: [],
        estado: [],
    });

    const [mostrarFiltro, setMostrarFiltro] = useState({
        sucursal: { open: false },
        tipoConteo: { open: false },
        auditorResp: { open: false },
        estado: { open: false },
    });

    const actualizarPrioridad = (filtro) => {
        setPrioridadFiltros((prev) => {
            const index = prev.indexOf(filtro);

            let nuevasPrioridades;

            // nuevo filtro → se agrega
            if (index === -1) {
                nuevasPrioridades = [...prev, filtro];
            }
            // filtro existente → se cortan los posteriores
            else {
                nuevasPrioridades = prev.slice(0, index + 1);
            }

            // 🔥 LIMPIAR filtros que perdieron prioridad
            setFiltrosTemp((prevTemp) => {
                const limpio = { ...prevTemp };

                Object.keys(limpio).forEach((key) => {
                    if (!nuevasPrioridades.includes(key)) {
                        limpio[key] = [];
                    }
                });

                return limpio;
            });

            // 🔥 LIMPIAR filtros aplicados también
            setFiltros((prevFiltros) => {
                const limpio = { ...prevFiltros };

                Object.keys(limpio).forEach((key) => {
                    if (!nuevasPrioridades.includes(key)) {
                        limpio[key] = [];
                    }
                });

                return limpio;
            });

            return nuevasPrioridades;
        });
    };

    const aplicarFiltros = (data, filtros, _, filtrosPermitidos = []) => {
        let resultado = [...data];

        filtrosPermitidos.forEach((filtro) => {
            if (filtro === "sucursal" && filtros.sucursal.length > 0) {
                resultado = resultado.filter((i) => filtros.sucursal.includes(i.sucursal));
            }

            if (filtro === "tipoConteo" && filtros.tipoConteo.length > 0) {
                resultado = resultado.filter((i) =>
                    filtros.tipoConteo.includes(i.tipo_conteo),
                );
            }

            if (filtro === "auditorResp" && filtros.auditorResp.length > 0) {
                resultado = resultado.filter((i) =>
                    filtros.auditorResp.includes(i.auditor_principal),
                );
            }

            if (filtro === "estado" && filtros.estado.length > 0) {
                resultado = resultado.filter((i) => filtros.estado.includes(i.estatus));
            }
        });

        return resultado;
    };

    useEffect(() => {
        if (!Array.isArray(auditorias)) return;

        let result = [...auditorias];

        prioridadFiltros.forEach((filtro) => {
            switch (filtro) {
                case "sucursal":
                    if (filtros.sucursal.length > 0) {
                        result = result?.filter((i) => filtros.sucursal.includes(i.sucursal));
                    }
                    break;

                case "tipoConteo":
                    if (filtros.tipoConteo.length > 0) {
                        result = result?.filter((i) =>
                            filtros.tipoConteo.includes(i.tipo_conteo),
                        );
                    }
                    break;

                case "auditorResp":
                    if (filtros.auditorResp.length > 0) {
                        result = result?.filter((i) =>
                            filtros.auditorResp.includes(i.auditor_principal),
                        );
                    }
                    break;

                case "estado":
                    if (filtros.estado.length > 0) {
                        result = result?.filter((i) => filtros.estado.includes(i.estatus));
                    }
                    break;

                default:
                    break;
            }
        });

        setDatosFiltrados(result);
    }, [auditorias, filtros, prioridadFiltros]);

    useEffect(() => {
        if (!Array.isArray(auditorias)) return;

        const getBaseData = (filtro) => {
            const index = prioridadFiltros.indexOf(filtro);

            // Si el filtro NO ha sido usado aún → usar data filtrada actual
            if (index === -1) {
                return aplicarFiltros(auditorias, filtros, null, prioridadFiltros);
            }

            // Si es el primero → data completa
            if (index === 0) {
                return auditorias;
            }

            // Solo aplicar filtros con MAYOR prioridad
            const filtrosPrevios = prioridadFiltros.slice(0, index);

            return aplicarFiltros(auditorias, filtros, null, filtrosPrevios);
        };

        // ORIGEN
        const sucursalOptions = [
            ...new Set(getBaseData("sucursal").map((i) => i.sucursal)),
        ].map((v) => ({ value: v, label: v }));

        const tipoConteoOptions = [
            ...new Set(getBaseData("tipoConteo").map((i) => i.tipo_conteo)),
        ].map((v) => ({ value: v, label: v }));

        const auditorRespOptions = [
            ...new Set(getBaseData("audtiorResp").map((i) => i.auditor_principal)),
        ].map((v) => ({ value: v, label: v }));

        const estadoOptions = [
            ...new Set(getBaseData("estado").map((i) => i.estatus)),
        ].map((v) => ({ value: v, label: v }));

        setOptions({
            sucursal: sucursalOptions,
            tipoConteo: tipoConteoOptions,
            auditorResp: auditorRespOptions,
            estado: estadoOptions,
        });
    }, [auditorias, filtros, prioridadFiltros]);

    useEffect(() => {
        onExecute();
    }, []);

    const onExecute = (
        //     comparacion,
        //     fechaInicio,
        //     fechaFin,
        //     asesor,
        //     cliente,
        //     esquema,
        //     fase
    ) => {
        // var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        // var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        // if (sucursales === undefined || sucursales === null || sucursales === "") {
        //     sucursales = "0";
        // }
        // if (adr === undefined || adr === null || adr === "") {
        //     adr = "0";
        // }
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`CargaInventario/ListadoAuditoriasProg`)
                .then((result) => {
                    setAuditorias(result);
                    setLoader({ ...loader, mostrar: false });
                    return;
                })
                .catch((error) => {

                    const mensaje =
                        error?.response?.data ||
                        error?.Mensaje ||
                        "Error al cargar las auditorias.";
                    Swal.fire("Cotización", mensaje, "error");
                    setLoader({ ...loader, mostrar: false });
                    return;
                });
        });
    };

    return (
        <PlantillaScreen
            titulo={`LISTADO DE AUDITORIAS PROGRAMADAS`}
            className={"auditorias-programadas-main-screen"}
            className_main={1}
        >
            <div className="auditorias-programadas-actions">
                <div
                    className="auditorias-programadas-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>
            <div className="auditorias-programadas">
                <LoaderScreen loader={loader} />
                {/* <div className="auditorias-programadas-filtro">
                   
                </div>
                <div className="auditorias-programadas-header">

                </div> */}
                <div className="auditorias-programadas-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Sucursal</th>
                                <th>
                                    <div>Tipo de conteo</div>
                                </th>
                                <th>
                                    <div>Fecha programada</div>
                                </th>
                                <th>
                                    <div>Fecha de ejecucion</div>
                                </th>
                                <th>
                                    <div>Folio</div>
                                </th>
                                <th>
                                    <div>Auditor Responsable</div>
                                </th>
                                <th>
                                    <div>Diferencias</div>
                                </th>
                                <th>
                                    <div>Porc. Confiabilidad</div>
                                </th>
                                <th>
                                    <div>Porc. Avance</div>
                                </th>
                                <th>
                                    <div>Confiabilidad SKU</div>
                                </th>
                                <th>
                                    <div>Estado</div>
                                </th>
                                <th>
                                    <div>Acciones</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {auditorias?.map((au) => (
                                <tr>
                                    <td className="ta-center">{capitalizePalabras(au.sucursal)}</td>
                                    <td className="ta-center">{au.tipo_conteo}</td>
                                    <td className="ta-center">{au.fecha_programada}</td>
                                    <td className="ta-center">{au.fecha_ejecucion}</td>
                                    <td className="ta-center">{au.folio}</td>
                                    <td className="ta-center">{au.auditor_principal}</td>
                                    <td className="ta-center">{au.diferencias === 0 ? "-" : au.diferencias}</td>
                                    <td className="ta-center">{au.porc_confiabilidad === 0 ? "-" : au.porc_confiabilidad}</td>
                                    <td className="ta-center">{au.porc_avance === 0 ? "-" : au.porc_avance}</td>
                                    <td className="ta-center">{au.conf_sku === 0 ? "-" : au.conf_sku}</td>
                                    <td className="ta-center">
                                        <span className={`auditoria-estado auditoria-estado-${au.estatus}`}>
                                            {estatusTexto[au.estatus]}
                                        </span>
                                    </td>
                                    <td className="ta-center">
                                        <SettingsIcon
                                            sx={{
                                                cursor: "pointer",
                                                color: "#374151",
                                                "&:hover": {
                                                    color: "#2563EB",
                                                    transform: "rotate(20deg)",
                                                    transition: "0.2s"
                                                }
                                            }}
                                            onClick={(e) => handleOpenMenu(e, au.folio)}
                                        />

                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl && auditoriaSelected === au.folio)}
                                            onClose={handleCloseMenu}
                                        >
                                            <MenuItem onClick={() => handleOpenModalCarga("I", au.id_sucursal)}>
                                                Cargar Archivo Inventario
                                            </MenuItem>

                                            <MenuItem onClick={() => handleOpenModalCarga("T", au.id_sucursal)}>
                                                Cargar Archivo en Transito
                                            </MenuItem>

                                            <MenuItem onClick={() => handleOpenModalCarga("S", au.id_sucursal)}>
                                                Cargar Archivo Surtido
                                            </MenuItem>

                                            <MenuItem onClick={() => handleClickConteo()}>
                                                Realizar conteo
                                            </MenuItem>

                                            <MenuItem>
                                                Generar Excel con resultados
                                            </MenuItem>
                                        </Menu>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <CargaArchivosInventarioModal
                open={openModalCarga}
                onClose={handleCloseModalCarga}
                auditoria={auditoriaSelected}
                tipoArchivo={archivoSelected}
                sucursal={sucursal}
            />
        </PlantillaScreen>
    );
};
